export const SESSION_ACTIONS = {
  LOGIN_CREATED: "LOGIN_CREATED",
  LOGIN_DESTROYED: "LOGIN_DESTROYED",
};

export const loginCreated = () => ({
  type: SESSION_ACTIONS.LOGIN_CREATED,
});

export const loginDestroyed = () => ({
  type: SESSION_ACTIONS.LOGIN_DESTROYED,
});
